import Axios from "axios";
import React, { Component } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    NavLink,
    useParams,
    useRouteMatch,
    useHistory,
    Redirect,
} from "react-router-dom";
import { useTranslation, withTranslation } from "react-i18next";
import hoistStatics from "hoist-non-react-statics";
import Func from "../../functions";
import Loading from "../../layouts/Loading";
import Env from "../../env";

let runInterval = null;

class Info extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount = async () => {
        this.props.i18n.changeLanguage(this.props.lngName);
    };

    setLoading = (v) => {
        this.setState({ isLoading: v });
    };

    copyClick = (element) => {
        $("#" + element).trigger("click");
    };

    render() {
        let showPostScriptStyle = this.props.styles.displayNormal;
        if (!this.props.data.detail.postscript) {
            showPostScriptStyle = this.props.styles.displayNone;
        }
        let showPayerNameStyle = this.props.styles.displayNormal;
        if (!this.props.data.payerName) {
            showPayerNameStyle = this.props.styles.displayNone;
        }

        let inputEndRadius = this.props.styles.inputEndRadius;

        return (
            <div>
                <div className="form-group row" style={showPayerNameStyle}>
                    <label className="col-sm-4 col-form-label text-sm">
                        {this.props.t("Cashier.PayerName")}
                    </label>
                    <div
                        className="col-sm-8"
                        style={this.props.styles.rowMarginBottom}
                    >
                        <input
                            id="payerName"
                            name="payerName"
                            className="form-control form-control-sm"
                            style={this.props.styles.inputReadOnlyStyle}
                            value={this.props.payerName}
                            readOnly
                        />
                    </div>
                </div>
                <div className="form-group row" style={showPostScriptStyle}>
                    <label className="col-sm-2 col-form-label text-sm">
                        {this.props.t("Cashier.Postscript")}
                    </label>
                    <div
                        className="input-group col-sm-10"
                        style={this.props.styles.rowMarginBottom}
                    >
                        <input
                            id="postscript"
                            name="postscript"
                            className="form-control form-control-sm"
                            style={this.props.styles.inputReadOnlyStyle}
                            value={this.props.data.detail.postscript}
                            onClick={(e) => this.props.copyData(e)}
                            readOnly
                        />
                        <div className="input-group-append">
                            <div
                                className="input-group-text"
                                style={inputEndRadius}
                                onClick={() => this.copyClick("postscript")}
                            >
                                <span className="fas text-xs">Copy</span>
                            </div>
                        </div>
                        <div className="input-group text-danger text-xs">
                            {this.props.t("Cashier.PostscriptContent")}
                        </div>
                    </div>
                </div>
                <div
                    className="form-group row"
                    style={this.props.styles.rowMarginBottom}
                >
                    <label className="col-sm-2 col-form-label text-sm">
                        {this.props.t("Cashier.Amount")}
                    </label>
                    <div
                        className="input-group col-sm-10"
                        style={this.props.styles.rowMarginBottom}
                    >
                        <input
                            id="amount"
                            name="amount"
                            className="form-control form-control-sm"
                            style={this.props.styles.inputReadOnlyStyle}
                            value={this.props.data.amount}
                            onClick={(e) => this.props.copyData(e)}
                            readOnly
                        />
                        <div className="input-group-append">
                            <div
                                className="input-group-text"
                                style={inputEndRadius}
                                onClick={() => this.copyClick("amount")}
                            >
                                <span className="fas text-xs">Copy</span>
                            </div>
                        </div>
                        <div className="input-group text-danger text-xs">
                            {this.props.t("Cashier.AmountContent1")}
                            <br />
                            {this.props.t("Cashier.AmountContent2")}
                            <br />
                            {this.props.t("Cashier.AmountContent3")}
                            <br />
                            {this.props.t("Cashier.AmountContent4")}
                        </div>
                    </div>
                </div>
                <div
                    className="form-group row"
                    style={this.props.styles.rowMarginBottom}
                >
                    <label className="col-sm-4 col-form-label text-sm">
                        {this.props.t("Cashier.BankName")}
                    </label>
                    <div
                        className="input-group col-sm-12"
                        style={this.props.styles.rowMarginBottom}
                    >
                        <input
                            id="bank_name"
                            name="bank_name"
                            className="form-control form-control-sm"
                            style={this.props.styles.inputReadOnlyStyle}
                            value={this.props.data.detail.bank}
                            onClick={(e) => this.props.copyData(e)}
                            readOnly
                        />
                        <div className="input-group-append">
                            <div
                                className="input-group-text"
                                onClick={() => this.copyClick("bank_name")}
                            >
                                <span className="fas text-xs">Copy</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="form-group row"
                    style={this.props.styles.rowMarginBottom}
                >
                    <label className="col-sm-4 col-form-label text-sm">
                        {this.props.t("Cashier.BankBranch")}
                    </label>
                    <div
                        className="input-group col-sm-12"
                        style={this.props.styles.rowMarginBottom}
                    >
                        <input
                            id="bank_branch"
                            name="bank_branch"
                            className="form-control form-control-sm"
                            style={this.props.styles.inputReadOnlyStyle}
                            value={this.props.data.detail.bank_branch}
                            onClick={(e) => this.props.copyData(e)}
                            readOnly
                        />
                        <div className="input-group-append">
                            <div
                                className="input-group-text"
                                onClick={() => this.copyClick("bank_branch")}
                            >
                                <span className="fas text-xs">Copy</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="form-group row"
                    style={this.props.styles.rowMarginBottom}
                >
                    <label className="col-sm-5 col-form-label text-sm">
                        {this.props.t("Cashier.CardNumber")}
                    </label>
                    <div
                        className="input-group col-sm-12"
                        style={this.props.styles.rowMarginBottom}
                    >
                        <input
                            id="card_no"
                            name="card_no"
                            className="form-control form-control-sm"
                            style={this.props.styles.inputReadOnlyStyle}
                            value={this.props.data.detail.card_no}
                            onClick={(e) => this.props.copyData(e)}
                            readOnly
                        />
                        <div className="input-group-append">
                            <div
                                className="input-group-text"
                                style={inputEndRadius}
                                onClick={() => this.copyClick("card_no")}
                            >
                                <span className="fas text-xs">Copy</span>
                            </div>
                        </div>
                        <div className="input-group text-danger text-xs">
                            {this.props.t("Cashier.CardNumberContent")}
                        </div>
                    </div>
                </div>
                <div
                    className="form-group row"
                    style={this.props.styles.rowMarginBottom}
                >
                    <label className="col-sm-12 col-form-label text-sm">
                        {this.props.t("Cashier.CardName")}
                    </label>
                    <div
                        className="input-group col-sm-12"
                        style={this.props.styles.rowMarginBottom}
                    >
                        <input
                            id="card_owner"
                            name="card_owner"
                            className="form-control form-control-sm"
                            style={this.props.styles.inputReadOnlyStyle}
                            value={this.props.data.detail.card_owner}
                            onClick={(e) => this.props.copyData(e)}
                            readOnly
                        />
                        <div className="input-group-append">
                            <div
                                className="input-group-text"
                                onClick={() => this.copyClick("card_owner")}
                            >
                                <span className="fas text-xs">Copy</span>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="form-group">
                    <label>{this.props.t("Cashier.OrderNo")}</label>
                    <div className="input-group mb-3">
                        <input
                            name="order_no"
                            className="form-control"
                            style={this.props.styles.inputReadOnlyStyle}
                            value={this.props.data.orderNo}
                            onClick={(e) => this.props.copyData(e)}
                            readOnly
                        />
                        <div className="input-group-append">
                            <div className="input-group-text">
                                <span className="fab fa-wpforms"></span>
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* <div className="form-group">
                    <label>{this.props.t("Cashier.OrderNo")}</label>
                    <div className="input-group mb-3">
                        <input
                            name="order_no"
                            className="form-control"
                            style={this.props.styles.inputReadOnlyStyle}
                            value={this.props.data.orderNo}
                            onClick={(e) => this.props.copyData(e)}
                            readOnly
                        />
                        <div className="input-group-append">
                            <div className="input-group-text">
                                <span className="fab fa-wpforms"></span>
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* <div className="form-group">
                    <label>{this.props.t("Cashier.CashierNo")}</label>
                    <div className="input-group mb-3">
                        <input
                            name="cashier_no"
                            className="form-control"
                            style={this.props.styles.inputReadOnlyStyle}
                            value={this.props.data.cashierNo}
                            onClick={(e) => this.props.copyData(e)}
                            readOnly
                        />
                        <div className="input-group-append">
                            <div className="input-group-text">
                                <span className="fas fa-cash-register"></span>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
        );
    }
}

export default hoistStatics(withTranslation()(Info), Info);
